/* eslint-disable import/no-anonymous-default-export */
export default (pay = { success: null, error: null }, action) => {
  switch (action.type) {
    case "PAYMENT_SUCCESS":
      return { ...pay, success: action.payload, error: null };
    case "PAYMENT_ERROR":
      return { ...pay, error: action.payload, success: null };
    default:
      return pay;
  }
};
